import React from 'react'
import UpdateReasonForm from '../../../component/form/master/reason/UpdateReasonForm'

export default function UpdateReason() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <UpdateReasonForm />
                    </div>
                </div>
            </div>
        </>
    )
}


